module.exports = __webpack_public_path__ + "assets/img/produccion-odm-rakumart-1.0ea38646.jpg";